import {
  Module,
  ModuleVariantsType,
  OnConfigureModulesCallback,
} from '../../../modules/types'
import { ProductInfoProduct } from '../../../types'
import { isGiftWithSingleVariant } from './utils'

const defaultProductModules: Module[] = [
  { __typename: 'ModuleImages' },
  { __typename: 'ModuleFromPrice' },
  { __typename: 'ModuleVariants', type: ModuleVariantsType.RADIO },
  { __typename: 'ModuleMoreInfo' },
  { __typename: 'ModuleButtons' },
]

const giftWithSingleVariantModules: Module[] = [
  { __typename: 'ModuleImages' },
  { __typename: 'ModulePrice' },
  { __typename: 'ModuleQuantity' },
  { __typename: 'ModuleMoreInfo' },
  { __typename: 'ModuleButtons' },
]

export const getConciergeModules: OnConfigureModulesCallback = ({
  product,
}: {
  product: ProductInfoProduct
}) =>
  isGiftWithSingleVariant(product)
    ? giftWithSingleVariantModules
    : defaultProductModules
